import { pictureGenerate, t } from '@process-creative/slate-theme-tools';

const template = document.createElement('template');
const CLASS_ZOOMED = "is-zoomed";
const MIN_DRAG_DELTA = 20;
const DEBOUNCE_COOLDOWN = 500;
const FONT_TYPE_CHINESE = "Chinese";
const BOTTLE_HEADING_CHINESE = t('products.personalisation.crafted_for_chinese');
const BOTTLE_HEADING_DEFAULT = t('products.personalisation.crafted_for_english');
const BOTTLE_NAME_DEFAULT_CHINESE = t('products.personalisation.your_name_chinese');
const BOTTLE_NAME_DEFAULT_ENGLISH = t('products.personalisation.your_name_english');

template.innerHTML = `
<style>
  :host {
    position: relative;
    width: 100vw;
    height: auto;
    margin: 1rem 0 0 0;
  }
  
  .bottle-image__container {
    background-color: #FAFAFA;
  }

  .bottle-image__wrapper {
    overflow: hidden;
    position: relative;
    color: #24495D;
    background-color: #FAFAFA;
    cursor: url("data:image/svg+xml,%3Csvg width='104' height='104' viewBox='0 0 104 104' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg filter='url(%23shadow)'%3E%3Ccircle cx='52' cy='52' r='32' fill='white'/%3E%3C/g%3E%3Cpath d='M51 51V43H53V51H61V53H53V61H51V53H43V51H51Z' fill='%230D0D0D'/%3E%3Cdefs%3E%3Cfilter id='shadow'%3E%3CfeDropShadow dx='0' dy='1' stdDeviation='2' flood-opacity='0.15'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E%0A"), auto;
  }

  .is-zoomed .bottle-image__wrapper {
    cursor: url("data:image/svg+xml,%3Csvg width='104' height='104' viewBox='0 0 104 104' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg filter='url(%23shadow)'%3E%3Ccircle cx='52' cy='52' r='32' fill='white'/%3E%3C/g%3E%3Cpath d='M43 51H61V53H43V51Z' fill='%230D0D0D'/%3E%3Cdefs%3E%3Cfilter id='shadow'%3E%3CfeDropShadow dx='0' dy='1' stdDeviation='2' flood-opacity='0.15'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E%0A"), auto;
    --offsetPercentX: 0;
    --offsetPercentY: 0;
    transform: translate(var(--offsetPercentX), var(--offsetPercentY)) scale(1.5);
  }

  .zoom-icon {
    position: absolute;
    top: 20px;
    left: 20px;
    width: 36px;
    height: 36px;
    pointer-events: none;
    display: none;
    z-index: 1;
  }

  .zoom-icon.is-minus {
    opacity: 0;
  }

  .is-zoomed .zoom-icon.is-plus {
    opacity: 0;
  }

  .is-zoomed .zoom-icon.is-minus {
    opacity: 1;
  }

  .bottle-image {
    position: relative;
    padding-bottom: 83.1%;
    overflow: hidden;
  }

  .bottle-image img {
    width: auto;
    max-width: 100%;
    height: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    object-position: center;
    object-fit: contain;
  }

  .bottle-text {
    position: absolute;
    left: 50%;
    bottom: 22.9%;
    transform: translate(-50%, 50%);
    display: flex;
    flex-flow: column;
    text-align: center;
    justify-content: center;
    text-transform: uppercase;
    width: 19.5%;
    height: 6.5%;
    padding: 0 1%;
    box-sizing: border-box;
  }

  [data-font-type="Modern"] .bottle-text {
    font-family: var(--font-secondary);
  }

  [data-font-type="Chinese"] .bottle-text {
    font-family: var(--font-tertiary);
  }

  .bottle-message {
    overflow: hidden;
    word-break: break-all;
  }

  .bottle-heading,
  .bottle-message {
    font-size: 4px;
    letter-spacing: 1.2px;
    line-height: 1;
  }

  .bottle-name {
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden; 
    font-size: 11px;
    letter-spacing: 1.5px;
  }

  [data-font-type="Modern"] .bottle-name {
    font-weight: 500;
  }


  .bottle-text.bottle-box-text {
    bottom: 45.95%;
    right: 31%;
    left: auto;
    width: 18.65%;
    transform: translate(50%, 50%);
  }

  .bottle-text.bottle-front-text {
    left: 32.65%;
    bottom: 34.64%;
  }

  @media screen and (max-width: 1100px) {
    .bottle-heading,
    .bottle-message {
      font-size: 0.36vw; /* 4px@1100 */
      letter-spacing: 0.3em; /* 1.2px@4px */
    }

    .bottle-name {
      font-size: 1vw; /* 11px@1100 */
      letter-spacing: 0.136em; /* 1.5px@11px */
    }

    .zoom-icon {
      display: block;
    }
  }

  @media screen and (min-width: 1800px) {
    :host {
      width: 81.25rem !important;
    }
  }
  
  @media screen and (min-width: 767px) {
    :host {
      width: 80vw;
    }
  }


  @media screen and (min-width: 991px) {
    :host {
      width: 55.1875rem !important;
    }
  }

  @media screen and (max-width: 766px) {
    .is-zoomed .bottle-image__wrapper {
      transform: translate(var(--offsetPercentX), var(--offsetPercentY)) scale(2);
    }
  }
</style>

<div class="bottle-image__container" data-zoom-container>
  <svg class="zoom-icon is-plus" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x=".5" y=".5" width="35" height="35" rx="17.5" stroke="#123247" stroke-opacity=".12"/><g clip-path="url(#a)" stroke="#123247" stroke-linecap="square" stroke-linejoin="round"><path d="M14.25 16.75h5M16.75 23a6.25 6.25 0 1 0 0-12.5 6.25 6.25 0 0 0 0 12.5zM21.17 21.17l4.33 4.33M16.75 14.25v5"/></g><defs><clipPath id="a"><path fill="#fff" transform="translate(8 8)" d="M0 0h20v20H0z"/></clipPath></defs></svg>
  <svg class="zoom-icon is-minus" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 36 36"><rect width="35" height="35" x=".5" y=".5" stroke="#123247" stroke-opacity=".12" rx="17.5"/><g clip-path="url(#a)"><path d="M14.25 16.75h5M16.75 23a6.25 6.25 0 1 0 0-12.5 6.25 6.25 0 0 0 0 12.5Zm4.42-1.83 4.33 4.33" stroke="#123247" stroke-linecap="square" stroke-linejoin="round"/></g><defs><clipPath id="a"><path d="M8 8h20v20H8z" fill="#fff"/></clipPath></defs></svg>
  <div class="bottle-image__wrapper" part="image" data-zoom-image>
    <div class="bottle-image"></div>
    <div class="bottle-text bottle-box-text">
      <span class="bottle-heading">CRAFTED FOR</span>
      <span class="bottle-name">YOUR NAME</span>
      <span class="bottle-message"></span>
    </div>
    <div class="bottle-text bottle-front-text">
      <span class="bottle-heading">CRAFTED FOR</span>
      <span class="bottle-name">YOUR NAME</span>
      <span class="bottle-message"></span>
    </div>
  </div>
</div>
`;

type PersonalisationData = {
  // These keys should match those that are set on all personalisation-input elements
  firstName:string;
  lastName:string;
  message:string;
}

type PersonalisationColor = {
  fontColor: string;
  labelColor: string;
};

export class PersonalisationImage extends HTMLElement {

  // Properties
  private readonly root: HTMLDivElement|null;
  //private bottleImages:HTMLElement[];
  private readonly image: HTMLImageElement;
  private readonly bottleHeading: NodeListOf<HTMLElement>|null = null;
  private readonly bottleName: NodeListOf<HTMLElement>|null = null;
  private readonly bottleMessage: NodeListOf<HTMLElement>|null = null;
  private readonly bottleTextContainer: NodeListOf<HTMLElement>|null = null;
  private readonly zoomWrap: HTMLElement | null = null;
  private readonly zoomContainer: HTMLElement | null = null;
  private readonly bottleImage = this.getAttribute('bottle-image');
  private readonly boxImage = this.getAttribute('box-image');
  private readonly mainImage = this.getAttribute('main-image');
  private readonly bottleNameValue = this.getAttribute('data-fname-value');
  private readonly bottleLastNameValue = this.getAttribute('data-lname-value');
  private readonly bottleMessageValue = this.getAttribute('data-message-value');

  private isDragging = false;
  private dragOriginX = 0;
  private dragOriginY = 0;
  private dragDx = 0;
  private dragDy = 0;
  private offsetStartX = 0;
  private offsetStartY = 0;
  private onDebounceCooldown = false;
  // Constructor
  constructor() {
    super();
    // Attach shadow root
    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(template.content.cloneNode(true));

    // Query things
    this.root = shadowRoot.querySelector('.bottle-image__wrapper')!;
    this.image = shadowRoot.querySelector('.bottle-image')!;
    this.bottleHeading = shadowRoot.querySelectorAll('.bottle-heading')!;
    this.bottleName = shadowRoot.querySelectorAll('.bottle-name')!;
    this.bottleMessage = shadowRoot.querySelectorAll('.bottle-message')!;
    this.bottleTextContainer = shadowRoot.querySelectorAll('.bottle-text')!;
    this.zoomWrap = shadowRoot.querySelector('[data-zoom-image]');
    this.zoomContainer = shadowRoot.querySelector('[data-zoom-container]');

    this.zoomWrap?.addEventListener('mousedown', this.onZoomStart);
    this.zoomWrap?.addEventListener('touchstart', this.onZoomStart);
    this.zoomWrap?.addEventListener('mousemove', this.onZoomMove);
    this.zoomWrap?.addEventListener('touchmove', this.onZoomMove);
    this.zoomWrap?.addEventListener('mouseup', this.onZoomEnd);
    this.zoomWrap?.addEventListener('touchend', this.onZoomEnd);
    
  }

  public setImage(imageType:string) {
    // let imageSrc = imageType == 'Bottle' ? this.bottleImage : this.boxImage;
    let imageSrc = this.mainImage;

    // let imageHTML =  pictureGenerate({
    //   class: 'c-cart-drawer__promo-product-image',
    //   src: imageSrc || '',
    //   srcSize: 920,
    //   sizes: [
    //     { size: 375, screen: 480 },
    //     { size: 920, screen: 1100 }
    //   ]
    // });
    // const imageHTMLNoCDN = imageHTML.replace(/\/\/cdn.shopify.com/g, '');
    // this.image.innerHTML = imageHTMLNoCDN;

    this.image.innerHTML =  `<picture><img class="c-cart-drawer__promo-product-image" src="${imageSrc || ''}"></picture>`
    this.root?.setAttribute('data-image-active',imageType);
  }

  public setLabel(fontType:string, personalisationData:PersonalisationData, personalisationColor:PersonalisationColor, userHasTyped: boolean) {
    const {
      firstName,
      lastName,
      message
    } = personalisationData

    let bottleNameDefault =  BOTTLE_NAME_DEFAULT_ENGLISH;
    if (fontType === FONT_TYPE_CHINESE) bottleNameDefault = BOTTLE_NAME_DEFAULT_CHINESE;
    
    const safeFirstName = firstName || this.getAttribute('data-fname-value') || bottleNameDefault;
    const safeLastName = lastName || this.getAttribute('data-lname-value') || '';

    this.root?.setAttribute('data-font-type',fontType);

    let fontColorName = personalisationColor.fontColor.split(":")
    let labelColorName = personalisationColor.labelColor.split(":")

    // this.bottleTextContainer.style.color = fontColorName[1];
    // this.bottleTextContainer.style.background = labelColorName[1];

    this.bottleTextContainer?.forEach(textContainer => {
      textContainer.style.color = fontColorName[1];
      textContainer.style.background = labelColorName[1];
    });

    this.bottleName?.forEach(name => {
      if (safeFirstName || safeLastName) {
        name.innerText = `${safeFirstName} ${safeLastName}`;
      } 
      else if (this.bottleNameValue || this.bottleLastNameValue) {
        name.innerText = `${this.bottleNameValue || ''} ${this.bottleLastNameValue || ''}`;
      } else {
        name.innerText = bottleNameDefault;
      }
    });
    
    this.bottleMessage?.forEach(messageElement => {
      if(this.bottleMessageValue) {
        messageElement.innerText = this.bottleMessageValue;
      } else messageElement.innerText = message;
    });

    // this.bottleMessage.innerText = message;
  }
  
  getClientPos = (e: any) => {
    let eventX = 0;
    let eventY = 0;

    // is this a touch event?
    if(e.changedTouches) {
      let firstTouch = e.changedTouches.item(0);
      eventX = firstTouch.clientX;
      eventY = firstTouch.clientY;
    } else {
      eventX = e.clientX;
      eventY = e.clientY;
    }
  
    return {
      x: eventX,
      y: eventY
    }
  }

  private onZoomStart = (e: any) => {
    let cPos = this.getClientPos(e);
    this.dragOriginX = cPos.x;
    this.dragOriginY = cPos.y;
    this.dragDx = 0;
    this.dragDy = 0;
    
    this.isDragging = true;
    if(this.zoomContainer?.classList.contains(CLASS_ZOOMED)) {
      e.preventDefault();
      e.stopPropagation();
      let percentFromCentreX = e.currentTarget.style.getPropertyValue('--offsetPercentX');
      let percentFromCentreY = e.currentTarget.style.getPropertyValue('--offsetPercentY');

      this.offsetStartX = parseFloat(percentFromCentreX.split('%')[0])
      this.offsetStartY = parseFloat(percentFromCentreY.split('%')[0])
    }
  }

  private onZoomMove = (e: any) => {
    let cPos = this.getClientPos(e);

    if(this.isDragging) {
      this.dragDx = cPos.x - this.dragOriginX;
      this.dragDy = cPos.y - this.dragOriginY;
    } else {
      this.dragDx = 0;
      this.dragDy = 0;
    }

    let zoomContainerRect = e.currentTarget.getBoundingClientRect();
    let zoomContainerCentreX = zoomContainerRect.x + (zoomContainerRect.width/2);
    let zoomContainerCentreY = zoomContainerRect.y + (zoomContainerRect.height/2);

    let percentFromCentreX = 0;
    let percentFromCentreY = 0;

    if(e.type === 'mousemove') {
      percentFromCentreX = (-1 * ((cPos.x - zoomContainerCentreX) / (zoomContainerRect.width/2)) * 100)/2;
      percentFromCentreY = (-1 * ((cPos.y - zoomContainerCentreY) / (zoomContainerRect.height/2)) * 100)/2;
    } else {
      percentFromCentreX = this.offsetStartX + ((this.dragDx / window.innerWidth) * 100);
      percentFromCentreY = this.offsetStartY + ((this.dragDy / window.innerHeight) * 100);
    }

    // cap values at +/- 50
    if(percentFromCentreX > 50) percentFromCentreX = 50;
    if(percentFromCentreX < -50) percentFromCentreX = -50;
    if(percentFromCentreY > 50) percentFromCentreY = 50;
    if(percentFromCentreY < -50) percentFromCentreY = -50;

    e.currentTarget.style.setProperty('--offsetPercentX', `${percentFromCentreX}%`);
    e.currentTarget.style.setProperty('--offsetPercentY', `${percentFromCentreY}%`);
  }

  private onZoomEnd = (e: any) => {
    if(this.onDebounceCooldown) {
      return;
    }
    this.onDebounceCooldown = true;
    window.setTimeout(() => {
      this.onDebounceCooldown = false;
    }, DEBOUNCE_COOLDOWN);

    // only counts as drag if exceeding the minimum countable change in position
    if(Math.abs(this.dragDx) < MIN_DRAG_DELTA && Math.abs(this.dragDy) < MIN_DRAG_DELTA) {
      this.isDragging = false;
    }

    // only start/end zooming if we aren't dragging
    if(!this.isDragging && !this.zoomContainer?.classList.contains(CLASS_ZOOMED)) {
      // Start Zooming
      this.zoomContainer?.classList.add(CLASS_ZOOMED);
    } else if(!this.isDragging) {
      // Stop Zooming
      this.zoomContainer?.classList.remove(CLASS_ZOOMED);
    }
  }

  public adjustFontSize(element: HTMLElement, maxLines: number = 1) {
    if (!element) return;
    element.style.fontSize = ''; 
    let style = window.getComputedStyle(element, null).getPropertyValue('font-size');
    let currentSize = parseFloat(style);

    if(maxLines === 1) {
        while(element.scrollWidth > element.offsetWidth && currentSize > 3) {
            currentSize -= 0.1;
            element.style.fontSize = currentSize + "px";
        }
    } 
    else {
        while(element.scrollHeight > element.offsetHeight * maxLines && currentSize > 3) {
            currentSize -= 0.1;
            element.style.fontSize = currentSize + "px";
        }
    }
  }

  updateBottleHeading(fontType: string): void {
    const headingText =
      fontType === FONT_TYPE_CHINESE
        ? BOTTLE_HEADING_CHINESE
        : BOTTLE_HEADING_DEFAULT;

    this.bottleHeading?.forEach(heading => {
      heading.innerText = headingText;
    });
  }

  clearName() {
    this.bottleName?.forEach(name => {
      name.innerText = BOTTLE_NAME_DEFAULT_ENGLISH
    });
  }

  clearMessage() {
    this.bottleName?.forEach(name => {
      name.innerText = ""
    });
  }

}

if (!customElements.get('personalisation-image')) {
  customElements.define('personalisation-image', PersonalisationImage);
}